import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { COGS, OperatingExpenses, RevenueChannel, Transaction, TransactionType } from '@contracts/interfaces/transaction.interfaces';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionsService } from '../../services/transactions.service';
import { FormControl } from '@angular/forms';
import { ProofService } from '../../services/proof.service';
import { HttpEventType } from '@angular/common/http';
import { MatTableDataSource } from '@angular/material/table';
import { ConnectionService } from '../../services/connection.service';
import { InvoicesService } from 'src/app/services/invoices.service';
import { InvoiceInterface, InvoiceStatus } from '@contracts/interfaces/invoice.interface';
import { MediaType } from '@contracts/interfaces/media.interfaces';
import { PDFService } from 'src/app/services/pdf.service';
import { Receipt, ReceiptSort } from '@contracts/interfaces/receipt.interface';
import { ReceiptsService } from 'src/app/services/receipts.service';
import { TransactionPresetsService } from 'src/app/services/transaction-presets.service';
import { TransactionPreset } from '@contracts/interfaces/transaction-preset.interface';

export interface DialogData {
  type: TransactionType;
  transactionHash: string;
  proofHash: string;
  index: number;
  dataSource: MatTableDataSource<Transaction>;
  pendingEvidence?: { file: string; };
}

interface SuggestedReceipt extends Receipt {
  _score?: number;
  _matchReason?: string;
}

interface InvoiceAttachmentWarning {
  message: string;
  transactionHash: string;
}

@Component({
  selector: 'app-item-search-dialog',
  templateUrl: 'transaction.dialog.html',
  styleUrls: ['./transaction.dialog.scss', '../common-dialog-styles.scss']
})
export class TransactionDialogComponent implements OnInit {

  public transactionType: TransactionType;
  public TransactionType = TransactionType;
  public MediaType = MediaType;

  public transactionPresets: TransactionPreset[] = [];
  public transactionPresetOptions: { label: string; value: string }[] = [
    { label: 'No preset', value: '' }
  ];

  public isLoading = true;

  public dateFormControl: FormControl | undefined;

  public src = "";
  public type = "image";

  public editVAT = false;
  public editSalesAmount = false;

  public tempSliderValue = 0;

  public transaction: Transaction | undefined;

  public pendingEvidence = false;

  public salesRevenue = false;
  public retailRevenue = false;
  public repairRevenue = false;
  public mspRevenue = false;
  public outcallRevenue = false;
  public ebayRevenue = false;

  public COGS = COGS;
  public operatingExpenses = OperatingExpenses;

  public receipts: Receipt[] = [];
  public suggestedReceipts: SuggestedReceipt[] = [];
  public isLoadingSuggestions = false;
  public viewMode: 'matcher' | 'preview' = 'matcher';
  public selectedReceiptSha1: string | null = null;
  public invoiceQuery = '';
  public lastInvoiceQuery = '';
  public invoiceAmountQuery = '';
  public lastInvoiceAmountQuery = '';
  public invoices: InvoiceInterface[] = [];
  public invoicesByAmount: InvoiceInterface[] = [];
  public isSearchingInvoices = false;
  public isSearchingInvoicesByAmount = false;
  public invalidInvoiceQuery = false;
  public invalidInvoiceAmountQuery = false;
  public invoiceSearchMessage = '';
  public invoiceAttachmentWarnings: { [invoiceNumber: number]: InvoiceAttachmentWarning } = {};
  public attachingInvoiceNumber: number | null = null;
  public receiptUploadProgress = {
    visible: false,
    completed: false,
    fileName: '',
    loaded: 0,
    total: null as number | null,
    percent: null as number | null,
    phase: ''
  };

  @ViewChild('receiptFileInput') receiptFileInput?: ElementRef<HTMLInputElement>;

  private readonly dayInMs = 1000 * 60 * 60 * 24;
  private readonly amountDeltaThresholdCents = 1200; // $12 buffer
  private readonly dayDeltaThreshold = 10;
  private shouldAutoShowReceipt = true;
  private invoiceWarningSearchToken = 0;
  private invoicePrefillToken = 0;
  private invoicePrefillTransactionHash = '';
  private receiptUploadResetTimer: any;

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // if (event.key == 'a') {
    //   this.previous();
    // } else if (event.key == 'd') {
    //   this.next();
    // }
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<TransactionDialogComponent>,
    public transactionService: TransactionsService,
    public proofService: ProofService,
    private connectionService: ConnectionService,
    private invoiceService: InvoicesService,
    private PDFService: PDFService,
    public receiptsService: ReceiptsService,
    private transactionPresetsService: TransactionPresetsService) { }

  ngOnInit() {
    this.transactionType = this.data.type;
    this.TransactionType = TransactionType;
    this.dialogRef.disableClose = true;
    this.dialogRef.backdropClick().subscribe(()=>{
      this.dialogRef.close(this.transaction);
    })

    this.loadPresets();
    this.load();

    if (this.data.pendingEvidence != undefined) {
      this.pendingEvidence = true;
    }
  }

  load() {

    this.type="image"

    this.transactionService.get(this.data.transactionHash).subscribe((transaction: Transaction) => {

      this.transaction = transaction;
      this.prepareInvoiceSearchForTransaction(transaction);
      if (this.transaction.preset === undefined && this.transaction.subcategory !== undefined) {
        this.transaction.preset = this.transaction.subcategory;
      }
      if (this.transaction.subcategory === undefined && this.transaction.preset !== undefined) {
        this.transaction.subcategory = this.transaction.preset;
      }

      this.receiptsService.getReceiptsByTransaction(transaction).subscribe((receipts: Receipt[]) => {
        this.updateReceiptState(receipts);
        this.refreshSuggestedReceipts();
      });

      this.dateFormControl = new FormControl(new Date(transaction.date));
      
      if (transaction.vat === undefined) {
        transaction.vat = 0;
      }
      
      console.log(this.transaction)

      this.isLoading = false;
    });

  }

  clearSalesRev () {
    if (this.transaction != undefined) {
      this.transaction.salesamount = 0;
    }
  }

  calcSalesRev() {
    if (this.transaction != undefined) {
      this.transaction.salesamount = this.calcRevenueSales(this.transaction.amount);
    }
  }

  calcRevenueSales(amount: number) {
    let exgst = ((amount / 11) * 10);
    let tmp = exgst - this.scale(exgst, 0, 1000, 0, 200);

    return +tmp.toFixed(0);
  } 

  scale (number: number, inMin: number, inMax: number, outMin: number, outMax: number) {
    return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
  }

  viewEvidence(transactionHash: string, evidenceHash: string) {
    this.proofService.loadSourceFile(transactionHash, evidenceHash).subscribe(type => {
      this.src = this.connectionService.address + "/proof-service/view?transactionHash="+transactionHash+"&proofHash="+evidenceHash;

      if (type == "application/pdf") {
        this.type = "pdf";
      } else {
        this.type = "image";
      }
    });
  }

  viewPendingEvidence(evidence: { file: string; }) {
    this.proofService.loadPendingEvidence(evidence).subscribe(type => {

      if (type == "application/pdf") {
        this.type = "pdf";
      } else {
        this.type = "image";
      }

      this.src = this.connectionService.address + "/evidence-service/view-pending-evidence?filename="+evidence.file;
    });
  }

  deleteEvidence(transactionHash: string, proofHash: string) {
    this.proofService.deleteProof(transactionHash, proofHash).subscribe(r => {
      this.load();
    })
  }
  
  applyPendingEvidence() {
    if (this.transaction == undefined) return; 
    this.proofService.applyPendingEvidence(this.data.pendingEvidence, this.transaction.source.sha1).subscribe(event => {
      this.data.pendingEvidence = undefined;
      this.pendingEvidence = false;
      this.load();
    });
  }

  private loadPresets() {
    this.transactionPresetsService.list().subscribe(presets => {
      this.transactionPresets = presets;
      this.transactionPresetOptions = [
        { label: 'No preset', value: '' },
        ...presets.map(preset => ({
          label: preset.name,
          value: preset.name
        }))
      ];
    }, () => {
      this.transactionPresets = [];
      this.transactionPresetOptions = [{ label: 'No preset', value: '' }];
    });
  }

  uploadReceipt(files: File[]) {
    if (this.transaction == undefined) return;
    if (!files || files.length === 0) return;

    this.startReceiptUploadProgress(files[0]);
    this.receiptsService.uploadReceipt(files, this.transaction.source.sha1).subscribe(event => {
      if (event.type === HttpEventType.Sent) {
        this.updateReceiptUploadProgress(0, files[0].size, 'Starting upload');
      }
      if (event.type === HttpEventType.UploadProgress) {
        this.updateReceiptUploadProgress(event.loaded || 0, event.total || files[0].size || null, 'Uploading');
      }
      if (event.type === HttpEventType.Response) {
        this.updateReceiptUploadProgress(files[0].size, files[0].size, 'Processing complete', true);
        this.shouldAutoShowReceipt = true;
        this.load();
      }  
    }, () => {
      this.receiptUploadProgress = {
        ...this.receiptUploadProgress,
        visible: true,
        completed: false,
        phase: 'Upload failed'
      };
    })
  }

  submitAdditionalProof(files: File[]) {
    this.proofService.submitProof(files, this.transaction.source.sha1).subscribe((event: any) => {
      if (event.type === HttpEventType.Response) {
        this.transaction = event.body.transaction;
        this.viewEvidence(this.transaction.source.sha1, this.transaction.proof[this.transaction.proof.length-1].sha1);
      }  
    });
    return;
  }

  editImage() {
    // let path = "transactions/9cbe221056ed7a8ad31635999f26b1d9774ab5a5/evidence";
    // let filename = "cd58754e764af41c54b60ad7f2b94aba47c261f7-order.ebay.com.au_ord_show_orderId=27-10671-48752.png";

    // this.mediaService.edit({
    //   filename: filename,
    //   path: path,
    //   size: null
    // }, (result: any)=> {
    //   console.log(this.transaction.proof[0])
    //   console.log("hit");
    // })
  }

  human (amount: number) {
    if (amount === undefined || amount === null) {
      amount = 0;
    }

    return new Intl.NumberFormat('en-US', { 
      style: 'currency', 
      currency: 'AUD' }).format(amount / 100);
  }

  calculateVAT() {
    if (this.transaction == undefined) return;
    this.transaction.vat = this.transactionService.calculateVAT(this.transaction.amount);
  }

  hasGSTRadio($event: any) {
    if ($event) {
      this.calculateVAT();
    } else {
      this.transaction.vat = 0;
    }

    this.saveChanges();
  }

  updateNote(value: string) {
    this.transaction.note = value;
    this.saveChanges();
  }

  requresEvidence(value: boolean) {
    this.transaction.internal = !value;
    this.saveChanges();
  }

  updateATOCategory(value: string) {
    this.transaction.atocategory = value;
    this.saveChanges();
  }

  moveTransactionDateBackOneDay() {
    if (this.transaction == undefined || !this.transaction.date) return;

    const transactionDate = new Date(this.transaction.date);
    if (isNaN(transactionDate.getTime())) return;

    transactionDate.setDate(transactionDate.getDate() - 1);
    this.transaction.date = transactionDate;
    this.saveChanges();
  }
 
  saveChanges() {
    if (this.transaction == undefined) return;
    this.transactionService.update(this.transaction).subscribe(r => {})
  }

  saveChangesAndClose() {
    if (this.transaction == undefined) return;
    this.transactionService.update(this.transaction).subscribe(r => {
      this.dialogRef.close(this.transaction);
    })
  }

  //    console.log(this.data.dataSource.filteredData[this.data.index+1]);
  next() {
    this.saveChanges();
    this.data.index++;

    if (this.data.dataSource.filteredData[this.data.index] == undefined) {
      this.dialogRef.close(this.transaction);
    } else {
      this.data.transactionHash = this.data.dataSource.filteredData[this.data.index].source.sha1;
      this.load();
    }
  }

  previous() {
    this.saveChanges();
    this.data.index--

    if (this.data.dataSource.filteredData[this.data.index] == undefined) {
      this.dialogRef.close(this.transaction);
    } else {
      this.data.transactionHash = this.data.dataSource.filteredData[this.data.index].source.sha1;
      this.load();
    }
  }

  toggleIgnore() {
    if (this.transaction == undefined) return;

    this.transaction.ignore = !this.transaction.ignore;
    this.saveChanges();
  }

  ignore() {
    this.transaction.ignore = true;
    this.saveChanges();
    this.dialogRef.close(this.transaction);
  }

  deleteTransaction() {
    if (this.transaction == undefined) return;

    this.transactionService.delete(this.transaction).subscribe(() => {
      this.dialogRef.close({ deleted: true, transaction: this.transaction });
    });
  }

  doThing(value: string | number) {
    if (this.transaction == undefined) return;
    this.editSalesAmount = false;
    this.transaction.salesamount = parseInt(value+"", 10);
  }


  subCategoryChanged() {
    if (!this.transaction) return;
    this.updatePreset(this.transaction.subcategory || '');
  }

  applyPreset(presetName: string) {
    if (this.transaction == undefined) return;
    const normalizedPresetName = presetName || '';
    this.transaction.preset = normalizedPresetName || null;
    this.transaction.subcategory = normalizedPresetName || null;

    if (!normalizedPresetName) {
      this.saveChanges();
      return;
    }

    // lookup preset from loaded list
    for (let preset of this.transactionPresets) {
      if (preset.name == normalizedPresetName) {

        // Apply GST
        if (preset.hasGST) {
          this.calculateVAT();
        } else {
          this.transaction.vat = 0;
        }

        // Apply category
        this.transaction.atocategory = preset.atocategory;

        // Requires evidence
        if (preset.requiresEvidence) {
          this.transaction.internal = false;
        } else {
          this.transaction.internal = true;
        }
      }
    }

    this.saveChanges();
  }

  updatePreset(value: string) {
    this.applyPreset(value);
  }

  getRevenueChannel(channel: string) {
    if (this.transaction == undefined) return;

    if (this.transaction.revenueChannel == undefined) {
      this.transaction.revenueChannel = {};
    }

    if (channel in this.transaction.revenueChannel) {
      return this.transaction.revenueChannel[channel as keyof RevenueChannel];
    } else {
      this.transaction.revenueChannel[channel as keyof RevenueChannel] = false;
      return false;
    }
  }

  updateRevenueChannel(channel: string) {
    if (this.transaction == undefined) return;

    if (this.transaction.revenueChannel == undefined) {
      this.transaction.revenueChannel = {};
    }

    if (channel in this.transaction.revenueChannel) {
      this.transaction.revenueChannel[channel as keyof RevenueChannel] = !this.transaction.revenueChannel[channel as keyof RevenueChannel];
    } else {
      this.transaction.revenueChannel[channel as keyof RevenueChannel] = true;
    }
  }

  expenseDirection(direction: string) {
    if (this.transaction == undefined) return;
    
    this.transaction.expenseDirection = direction;

    this.saveChanges();
  }


  saveSorted($event: boolean) {
    console.log($event)
    this.transaction.sorted = $event;
    this.saveChanges();
  }

  onInvoiceQueryChange(query: string): void {
    this.invoiceQuery = query;
    this.lastInvoiceQuery = query;
    this.invalidInvoiceQuery = false;
    this.invoiceSearchMessage = '';

    const invoiceNumber = parseInt((query || '').trim(), 10);
    if (isNaN(invoiceNumber)) {
      this.isSearchingInvoices = false;
      this.invalidInvoiceQuery = !!(query || '').trim();
      this.invoices = [];
      return;
    }

    this.isSearchingInvoices = true;
    this.invoiceService.get(invoiceNumber).subscribe({
      next: (invoice: InvoiceInterface) => {
        this.invoices = invoice ? [invoice] : [];
        this.isSearchingInvoices = false;
        this.refreshInvoiceAttachmentWarnings();
      },
      error: () => {
        this.invoices = [];
        this.isSearchingInvoices = false;
        this.refreshInvoiceAttachmentWarnings();
      }
    });
  }

  onInvoiceCancelled(): void {
    this.invoiceQuery = '';
    this.lastInvoiceQuery = '';
    this.isSearchingInvoices = false;
    this.invalidInvoiceQuery = false;
    this.invoices = [];
    this.refreshInvoiceAttachmentWarnings();
  }

  onInvoiceAmountQueryChange(query: string): void {
    this.invoiceAmountQuery = query;
    this.lastInvoiceAmountQuery = query;
    this.invalidInvoiceAmountQuery = false;
    this.invoiceSearchMessage = '';

    const normalised = (query || '').trim().replace(/[$,\s]/g, '');
    if (!normalised) {
      this.isSearchingInvoicesByAmount = false;
      this.invoicesByAmount = [];
      return;
    }

    const amount = parseFloat(normalised);
    if (isNaN(amount)) {
      this.isSearchingInvoicesByAmount = false;
      this.invalidInvoiceAmountQuery = true;
      this.invoicesByAmount = [];
      return;
    }

    this.isSearchingInvoicesByAmount = true;
    this.invoiceService.find({ total: Math.round(amount * 100) }).subscribe({
      next: (invoices: InvoiceInterface[]) => {
        this.invoicesByAmount = invoices || [];
        this.isSearchingInvoicesByAmount = false;
        this.refreshInvoiceAttachmentWarnings();
      },
      error: () => {
        this.invoicesByAmount = [];
        this.isSearchingInvoicesByAmount = false;
        this.refreshInvoiceAttachmentWarnings();
      }
    });
  }

  onInvoiceAmountCancelled(): void {
    this.invoiceAmountQuery = '';
    this.lastInvoiceAmountQuery = '';
    this.isSearchingInvoicesByAmount = false;
    this.invalidInvoiceAmountQuery = false;
    this.invoicesByAmount = [];
    this.refreshInvoiceAttachmentWarnings();
  }

  openInvoice(invoice: InvoiceInterface): void {
    this.invoiceService.openInvoiceDialog(invoice, () => {
      if (this.lastInvoiceQuery) {
        this.onInvoiceQueryChange(this.lastInvoiceQuery);
      }
      if (this.lastInvoiceAmountQuery) {
        this.onInvoiceAmountQueryChange(this.lastInvoiceAmountQuery);
      }
    });
  }

  attachInvoice(invoice: InvoiceInterface): void {
    if (!this.transaction) return;

    const warning = this.getInvoiceAttachmentWarning(invoice)?.message;
    if (warning && !window.confirm(`${warning}\n\nAttach it to this transaction as well?`)) {
      return;
    }
    const allowAlreadyAttached = !!warning;

    const validatedInvoice = this.invoiceService.validate(invoice);
    if (validatedInvoice.status === InvoiceStatus.Unpaid) {
      this.invoiceSearchMessage = `Invoice #${invoice.number} is unpaid. Record payment before attaching.`;
      this.invoiceService.openRecordPaymentDialog(validatedInvoice, false, () => {
        this.invoiceService.get(invoice.number).subscribe({
          next: (updatedInvoice: InvoiceInterface) => {
            const paidInvoice = this.invoiceService.validate(updatedInvoice || validatedInvoice);
            this.replaceSearchedInvoice(paidInvoice);

            if (paidInvoice.status === InvoiceStatus.Unpaid) {
              this.invoiceSearchMessage = `Invoice #${invoice.number} is still unpaid.`;
              return;
            }

            this.attachPaidInvoice(paidInvoice, allowAlreadyAttached);
          },
          error: () => {
            this.invoiceSearchMessage = `Could not confirm payment for invoice #${invoice.number}.`;
          }
        });
      });
      return;
    }

    this.attachPaidInvoice(validatedInvoice, allowAlreadyAttached);
  }

  private prepareInvoiceSearchForTransaction(transaction: Transaction): void {
    const transactionHash = transaction?.source?.sha1 || this.data.transactionHash;

    if (this.invoicePrefillTransactionHash === transactionHash) {
      return;
    }

    this.invoicePrefillTransactionHash = transactionHash;
    this.invoiceQuery = '';
    this.lastInvoiceQuery = '';
    this.invoices = [];
    this.invalidInvoiceQuery = false;
    this.prefillInvoiceNumberFromDescription(transaction, transactionHash);
  }

  private prefillInvoiceNumberFromDescription(transaction: Transaction, transactionHash: string): void {
    const description = (transaction?.description || '').trim();
    if (!description) {
      return;
    }

    const token = ++this.invoicePrefillToken;

    this.invoiceService.getAvailableInvoiceNumber().subscribe({
      next: (result: any) => {
        const latestInvoiceNumber = Number(result?.number) - 1;
        const activeTransactionHash = this.transaction?.source?.sha1 || this.data.transactionHash;

        if (token !== this.invoicePrefillToken || activeTransactionHash !== transactionHash || this.invoiceQuery.trim()) {
          return;
        }

        const invoiceNumber = this.extractBelievableInvoiceNumber(description, latestInvoiceNumber);
        if (invoiceNumber === null) {
          return;
        }

        this.onInvoiceQueryChange(String(invoiceNumber));
      },
      error: () => {}
    });
  }

  private extractBelievableInvoiceNumber(description: string, latestInvoiceNumber: number): number | null {
    if (!Number.isInteger(latestInvoiceNumber) || latestInvoiceNumber < 1) {
      return null;
    }

    const oldestBelievableInvoiceNumber = Math.max(1, latestInvoiceNumber - 100);
    const isBelievable = (value: string) => {
      const invoiceNumber = Number(value);
      return Number.isInteger(invoiceNumber) &&
        invoiceNumber >= oldestBelievableInvoiceNumber &&
        invoiceNumber <= latestInvoiceNumber;
    };
    const explicitInvoicePattern = /\b(?:inv|invoice)\s*(?:(?:no|number)\.?\s*)?[#:\-]?\s*(\d{4,})\b/gi;
    let match: RegExpExecArray | null;

    while ((match = explicitInvoicePattern.exec(description)) !== null) {
      if (isBelievable(match[1])) {
        return Number(match[1]);
      }
    }

    const fourDigitCandidates = description.match(/\b\d{4}\b/g) || [];
    const believableCandidate = fourDigitCandidates.find(isBelievable);

    return believableCandidate ? Number(believableCandidate) : null;
  }

  private attachPaidInvoice(invoice: InvoiceInterface, allowAlreadyAttached = false): void {
    if (!this.transaction) return;

    if (!invoice?.pdf?.file) {
      this.invoiceSearchMessage = `Invoice #${invoice?.number || ''} has no PDF template.`;
      return;
    }

    const attachWithHash = (hash: string) => {
      if (!hash) {
        this.attachingInvoiceNumber = null;
        this.invoiceSearchMessage = `Could not prepare invoice #${invoice.number}.`;
        return;
      }

      this.transactionService.attachInvoice(this.transaction, hash, invoice.number, allowAlreadyAttached).subscribe({
        next: (result: any) => {
          this.attachingInvoiceNumber = null;
          this.invoiceSearchMessage = `Invoice #${invoice.number} attached.`;
          if (result?.response) {
            this.transaction = result.response;
          }
          this.shouldAutoShowReceipt = true;
          this.load();
        },
        error: (error: any) => {
          this.attachingInvoiceNumber = null;
          const message = error?.error?.message || `Could not attach invoice #${invoice.number}.`;
          if (!allowAlreadyAttached && error?.status === 409 &&
              ['invoice already attached', 'receipt already attached'].includes(error?.error?.error) &&
              window.confirm(`${message}\n\nAttach it to this transaction as well?`)) {
            this.attachPaidInvoice(invoice, true);
            return;
          }
          this.invoiceSearchMessage = message;
          this.refreshInvoiceAttachmentWarnings();
        }
      });
    };

    this.attachingInvoiceNumber = invoice.number;
    this.invoiceSearchMessage = `Preparing invoice #${invoice.number}...`;
    this.PDFService.check(invoice.pdf.file, invoice).subscribe({
      next: (checkResult: any) => {
        if (checkResult?.hash) {
          attachWithHash(checkResult.hash);
          return;
        }

        this.invoiceSearchMessage = `Generating invoice #${invoice.number}...`;
        this.PDFService.generatePDF2(invoice.pdf.file, invoice).subscribe({
          next: (generatedResult: any) => {
            attachWithHash(generatedResult?.hash);
          },
          error: () => {
            this.attachingInvoiceNumber = null;
            this.invoiceSearchMessage = `Could not generate invoice #${invoice.number}.`;
          }
        });
      },
      error: () => {
        this.attachingInvoiceNumber = null;
        this.invoiceSearchMessage = `Could not check invoice #${invoice.number}.`;
      }
    });
  }

  private replaceSearchedInvoice(invoice: InvoiceInterface): void {
    if (!invoice?.number) {
      return;
    }

    this.invoices = this.invoices.map(existing => existing?.number === invoice.number ? invoice : existing);
    this.invoicesByAmount = this.invoicesByAmount.map(existing => existing?.number === invoice.number ? invoice : existing);
  }

  refreshSuggestedReceipts() {
    if (!this.transaction) {
      this.suggestedReceipts = [];
      return;
    }

    this.isLoadingSuggestions = true;
    this.receiptsService.getReceipts(ReceiptSort.UNSORTED).subscribe((receipts: Receipt[]) => {
      const candidates = receipts
        .filter(r => !this.isReceiptAlreadyLinked(r) && (!r.transactionID || (this.transaction && r.transactionID === this.transaction.source.sha1)))
        .map(r => this.scoreReceipt(r))
        .filter((r): r is SuggestedReceipt => !!r)
        .sort((a, b) => (a._score || 0) - (b._score || 0))
        .slice(0, 6);

      this.suggestedReceipts = candidates;
      this.isLoadingSuggestions = false;
    }, () => {
      this.isLoadingSuggestions = false;
    });
  }

  attachReceipt(receipt: Receipt) {
    if (this.transaction == undefined) return;

    if (this.transaction.receipts == undefined)  {
      this.transaction.receipts = [];
    }

    if (!this.receiptsService.hasReceipt(receipt, this.transaction)) {
      this.transaction.receipts.push(receipt);
    }

    this.transaction = this.receiptsService.removeDuplicateReceipts(this.transaction);
    receipt.transactionID = this.transaction.source.sha1;

    this.transactionService.update(this.transaction).subscribe(() => {
      this.receiptsService.updateReceipt(receipt).subscribe(() => {
        this.shouldAutoShowReceipt = true;
        this.load();
      });
    });
  }

  unlinkReceipt(receipt: Receipt) {
    if (this.transaction == undefined) return;

    const isInvoiceReceipt = receipt?.file?.originalFilename === 'invoice.pdf';
    this.transaction.receipts = (this.transaction.receipts || []).filter(r => r.sha1 !== receipt.sha1);
    // Use null so the unlink survives JSON serialization and is persisted by
    // the receipt update endpoint. Undefined properties are omitted entirely.
    receipt.transactionID = null;

    if (isInvoiceReceipt) {
      delete this.transaction.invoice;
    }

    this.transactionService.update(this.transaction).subscribe(() => {
      this.receiptsService.updateReceipt(receipt).subscribe(() => {
        this.shouldAutoShowReceipt = (this.transaction?.receipts?.length || 0) === 0;
        this.load();
      });
    });
  }

  triggerReceiptUpload() {
    this.receiptFileInput?.nativeElement.click();
  }

  handleReceiptFile(files: FileList | null) {
    if (!files || files.length === 0) {
      return;
    }
    this.uploadReceipt([files[0]]);
    if (this.receiptFileInput) {
      this.receiptFileInput.nativeElement.value = "";
    }
  }

  handleReceiptDrop(event: { addedFiles?: File[] }) {
    if (!event?.addedFiles || event.addedFiles.length === 0) {
      return;
    }
    this.uploadReceipt(event.addedFiles);
  }

  formatReceiptAmount(receipt: Receipt) {
    const amount = this.getReceiptAmountCents(receipt);
    if (amount === null) {
      return 'Amount unknown';
    }
    return this.human(amount);
  }

  formatBytes(bytes: number | null | undefined): string {
    const value = bytes || 0;
    if (value < 1024) {
      return `${value} B`;
    }
    if (value < 1024 * 1024) {
      return `${(value / 1024).toFixed(1)} KB`;
    }
    return `${(value / 1024 / 1024).toFixed(2)} MB`;
  }

  logTransaction(): void {
    // Capture a snapshot so later changes do not alter earlier console entries.
    console.log('Transaction snapshot', new Date().toISOString(), JSON.parse(JSON.stringify(this.transaction ?? null)));
  }

  private startReceiptUploadProgress(file: File): void {
    if (this.receiptUploadResetTimer) {
      clearTimeout(this.receiptUploadResetTimer);
    }

    this.receiptUploadProgress = {
      visible: true,
      completed: false,
      fileName: file?.name || 'Receipt file',
      loaded: 0,
      total: file?.size || null,
      percent: 0,
      phase: 'Queued'
    };
  }

  private updateReceiptUploadProgress(loaded: number, total: number | null, phase: string, completed: boolean = false): void {
    const safeTotal = total && total > 0 ? total : null;
    const safeLoaded = Math.max(0, loaded || 0);
    const percent = safeTotal ? Math.min(100, Math.round((safeLoaded / safeTotal) * 100)) : null;

    this.receiptUploadProgress = {
      ...this.receiptUploadProgress,
      visible: true,
      completed,
      loaded: safeLoaded,
      total: safeTotal,
      percent: completed ? 100 : percent,
      phase
    };

    if (completed) {
      this.receiptUploadResetTimer = setTimeout(() => {
        this.receiptUploadProgress = {
          visible: false,
          completed: false,
          fileName: '',
          loaded: 0,
          total: null,
          percent: null,
          phase: ''
        };
      }, 3000);
    }
  }

  private scoreReceipt(receipt: Receipt): SuggestedReceipt | null {
    if (!this.transaction) return null;

    const transactionAmount = this.transaction.amount;
    const transactionDate = this.transaction.date ? new Date(this.transaction.date).getTime() : null;

    const receiptAmount = this.getReceiptAmountCents(receipt);
    const receiptDate = this.getReceiptDateMs(receipt);

    const amountDelta = receiptAmount !== null ? Math.abs(receiptAmount - transactionAmount) : null;
    const dayDelta = (transactionDate && receiptDate) ? Math.abs(transactionDate - receiptDate) / this.dayInMs : null;

    const amountClose = amountDelta !== null && amountDelta <= this.amountDeltaThresholdCents;
    const dateClose = dayDelta !== null && dayDelta <= this.dayDeltaThreshold;

    if (!amountClose && !dateClose) {
      return null;
    }

    const score = (amountDelta !== null ? amountDelta : this.amountDeltaThresholdCents * 2) + (dayDelta !== null ? dayDelta * 200 : this.dayDeltaThreshold * 50);

    return {
      ...receipt,
      _score: score,
      _matchReason: this.buildMatchReason(amountDelta, dayDelta)
    };
  }

  private buildMatchReason(amountDelta: number | null, dayDelta: number | null): string {
    const parts: string[] = [];

    if (amountDelta !== null) {
      parts.push(amountDelta === 0 ? 'Exact amount' : `Within $${(amountDelta / 100).toFixed(2)}`);
    }

    if (dayDelta !== null) {
      const rounded = Math.round(dayDelta);
      if (rounded === 0) {
        parts.push('Same day');
      } else {
        parts.push(`Within ${rounded} day${rounded === 1 ? '' : 's'}`);
      }
    }

    return parts.join(' - ');
  }

  private getReceiptAmountCents(receipt: Receipt): number | null {
    if (receipt.amount === undefined || receipt.amount === null || receipt.amount === '') {
      return null;
    }

    const numericAmount = typeof receipt.amount === 'string' ? parseFloat(receipt.amount) : receipt.amount as any;
    if (numericAmount === undefined || numericAmount === null || isNaN(numericAmount)) {
      return null;
    }

    return Math.round(+numericAmount * 100);
  }

  private getReceiptDateMs(receipt: Receipt): number | null {
    if (!receipt.date) {
      return null;
    }
    const d = new Date(receipt.date);
    return isNaN(d.getTime()) ? null : d.getTime();
  }

  private isReceiptAlreadyLinked(receipt: Receipt): boolean {
    return this.receipts.some(r => r.sha1 === receipt.sha1);
  }

  private updateReceiptState(receipts: Receipt[]) {
    this.receipts = receipts;

    if (this.receipts.length === 0) {
      this.selectedReceiptSha1 = null;
      this.viewMode = 'matcher';
      return;
    }

    if (!this.selectedReceiptSha1 || !this.receipts.some(r => r.sha1 === this.selectedReceiptSha1)) {
      this.selectedReceiptSha1 = this.receipts[0].sha1;
    }

    if (this.shouldAutoShowReceipt) {
      this.viewMode = 'preview';
    }
  }

  setViewMode(mode: 'matcher' | 'preview') {
    this.viewMode = mode;
    this.shouldAutoShowReceipt = mode === 'preview';
  }

  selectReceipt(receipt: Receipt) {
    this.selectedReceiptSha1 = receipt.sha1;
    this.viewMode = 'preview';
    this.shouldAutoShowReceipt = true;
  }

  get selectedReceipt(): Receipt | undefined {
    if (!this.receipts.length) return undefined;
    return this.receipts.find(r => r.sha1 === this.selectedReceiptSha1) || this.receipts[0];
  }

  hasReceipts() {
    return this.receipts.length > 0;
  }

  get combinedInvoices(): InvoiceInterface[] {
    const combined = [...this.invoices, ...this.invoicesByAmount];
    const seen = new Set<number>();

    return combined.filter((invoice) => {
      if (!invoice?.number || seen.has(invoice.number)) {
        return false;
      }
      seen.add(invoice.number);
      return true;
    });
  }

  getInvoiceAttachmentWarning(invoice: InvoiceInterface): InvoiceAttachmentWarning | null {
    if (!invoice?.number) {
      return null;
    }

    return this.invoiceAttachmentWarnings[invoice.number] || null;
  }

  openInvoiceAttachmentWarning(invoice: InvoiceInterface): void {
    const warning = this.getInvoiceAttachmentWarning(invoice);
    if (!warning?.transactionHash) {
      return;
    }

    this.saveChanges();

    const linkedIndex = this.data.dataSource?.filteredData?.findIndex(t => t?.source?.sha1 === warning.transactionHash);
    this.transactionService.openTransactionDialog(
      null,
      warning.transactionHash,
      linkedIndex !== undefined && linkedIndex >= 0 ? linkedIndex : this.data.index,
      this.data.dataSource,
      () => {
        this.refreshInvoiceAttachmentWarnings();
      }
    );
  }

  private refreshInvoiceAttachmentWarnings(): void {
    if (!this.transaction) {
      this.invoiceAttachmentWarnings = {};
      return;
    }

    const invoiceNumbers = Array.from(new Set(
      [...this.invoices, ...this.invoicesByAmount]
        .map(invoice => invoice?.number)
        .filter((number): number is number => !!number)
    ));

    const token = ++this.invoiceWarningSearchToken;
    this.invoiceAttachmentWarnings = {};

    for (let invoiceNumber of invoiceNumbers) {
      this.transactionService.find({ "invoice.number": { $in: [invoiceNumber, `${invoiceNumber}`] } }, 0, 5).subscribe({
        next: (transactions: Transaction[]) => {
          if (token !== this.invoiceWarningSearchToken || !this.transaction) {
            return;
          }

          const otherTransactions = (transactions || []).filter(t => t?.source?.sha1 !== this.transaction?.source?.sha1);
          for (let otherTransaction of otherTransactions) {
            this.receiptsService.getReceiptsByTransaction(otherTransaction).subscribe((receipts: Receipt[]) => {
              if (token !== this.invoiceWarningSearchToken || !this.transaction) {
                return;
              }

              if (!(receipts || []).some(receipt => receipt?.file?.originalFilename === 'invoice.pdf')) {
                return;
              }

              this.invoiceAttachmentWarnings = {
                ...this.invoiceAttachmentWarnings,
                [invoiceNumber]: this.buildInvoiceAttachmentWarning(invoiceNumber, otherTransaction)
              };
            });
          }
        }
      });
    }
  }

  private buildInvoiceAttachmentWarning(invoiceNumber: number, transaction: Transaction): InvoiceAttachmentWarning {
    const date = transaction.date ? new Date(transaction.date).toLocaleDateString('en-AU') : 'unknown date';
    const description = transaction.description || 'another transaction';
    return {
      message: `Invoice #${invoiceNumber} is already attached to ${description} (${date}).`,
      transactionHash: transaction?.source?.sha1 || ''
    };
  }

  get hasInvoiceSearch(): boolean {
    return !!this.lastInvoiceQuery || !!this.lastInvoiceAmountQuery;
  }

  get isSearchingAnyInvoice(): boolean {
    return this.isSearchingInvoices || this.isSearchingInvoicesByAmount;
  }

  get showInvoiceEmptyState(): boolean {
    return !this.hasInvoiceSearch;
  }

  get showInvoiceNoResults(): boolean {
    return this.hasInvoiceSearch &&
      !this.isSearchingAnyInvoice &&
      !this.invalidInvoiceQuery &&
      !this.invalidInvoiceAmountQuery &&
      this.combinedInvoices.length === 0;
  }

  setDesiredInvoiceAmount(amount: string | number) {
    if (!this.transaction) return;
    if (!this.transaction.additional) {
      this.transaction.additional = {};
    }
    const numeric = typeof amount === 'string' ? parseFloat(amount) : amount;
    const cents = isNaN(+numeric) ? null : Math.round(+numeric);
    this.transaction.additional.desiredInvoiceAmount = cents;
    this.saveChanges();
  }
}

